const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB

export const validateFileSize = (file) => {
    return file.size <= MAX_FILE_SIZE;
};


export const validateImageDimensions = (file, uploadImage) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
        img.src = e.target.result;
    };

    img.onload = () => {
        const width = img.width;
        const height = img.height;
        const isValid = width === 220 && height === 220;
        uploadImage(isValid);
        console.log(isValid)
    };

    img.onerror = () => {
        uploadImage(false);
    };

    reader.readAsDataURL(file);
};